import { render, staticRenderFns } from "./GrievancePolicy.vue?vue&type=template&id=125e7d5b&scoped=true"
import script from "./GrievancePolicy.vue?vue&type=script&lang=js"
export * from "./GrievancePolicy.vue?vue&type=script&lang=js"
import style0 from "./GrievancePolicy.vue?vue&type=style&index=0&id=125e7d5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e7d5b",
  null
  
)

export default component.exports